import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { WEARABLE_PROVIDERS, WearableProvider } from '@/config/wearableProviders';

interface DynamicAttributionProps {
    /** Active data source IDs to show attribution for, e.g. ['garmin'], ['whoop', 'coros'] */
    sources: string[];
}

const DynamicAttribution: React.FC<DynamicAttributionProps> = ({ sources }) => {
    const { isDark } = useTheme();
    const providers = sources
        .map(s => WEARABLE_PROVIDERS.find(p => p.id === s))
        .filter((p): p is WearableProvider => !!p);

    if (providers.length === 0) return null;

    const isMulti = providers.length > 1;
    const size = isMulti ? 24 : 30;
    const gap = isMulti ? 4 : 6;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                margin: 16,
                width: '100%',
                boxSizing: 'border-box',
                gap: 12,
            }}
        >
            {providers.map((provider, index) => (
                <React.Fragment key={provider.id}>
                    {index > 0 && (
                        <span
                            className="cgm-text-secondary"
                            style={{ fontSize: 12, fontWeight: 600, opacity: 0.6 }}
                        >
                            &times;
                        </span>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={isDark && provider.logoAlt ? provider.logoAlt : provider.logo}
                            alt={`${provider.label} logo`}
                            style={{
                                width: size,
                                height: size,
                                marginRight: gap,
                                opacity: 0.85,
                                padding: 0,
                                borderRadius: provider.logoStyle?.borderRadius || 0,
                            }}
                        />
                        <span
                            className="cgm-text-primary"
                            style={{
                                fontSize: 10,
                                fontWeight: 600,
                                letterSpacing: '0.05em',
                                opacity: 0.85,
                                textShadow: isDark ? '0 1px 2px #000' : '0 1px 2px #fff',
                                padding: 0,
                            }}
                        >
                            {isMulti ? provider.label : `Data powered by ${provider.label}`}
                        </span>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
};

export default DynamicAttribution;
